import * as React from 'react'
import _ from 'lodash'

import config from '../../../../constants/config'
import { AxiosInstance } from '../../../../utils/RequestMethods'
import { JobT } from '../../../../types/Job'

import { ContactHistoryT } from '../ContactTab/ContactTab'
import ContactFormSubmission from '../ContactTab/ContactFormSubmission'
import ContactTranscription from '../ContactTab/ContactTranscription'
import ContactPhone from '../ContactTab/ContactPhone'
import ContactSms from '../ContactTab/ContactSms'
import { Button } from 'react-bootstrap'
import ButtonLoading from '../../../../components/ButtonLoading'
import { copyObject } from '../../../../utils'


interface IDisputeCommunicationsTab {
    job : JobT
}

const DisputeCommunicationsTab : React.FC<IDisputeCommunicationsTab> = (props : IDisputeCommunicationsTab) : JSX.Element => {
    const [communications, setCommunications] = React.useState<string>('')


    React.useEffect(() => {
        init()
    }, [])


    const init = async () : Promise<void> => {
        let comms = AxiosInstance.get(`${config.url.jobs}/${props.job.id}/communications/dispute_annotations`).then((res) => {
            setCommunications(res.data)
            console.log('DISPUTE ANNOTATIONS')
            console.log(res.data)
        })
    }


    const renderContactHistory = () : Array<JSX.Element> => {
        if (_.isArray(communications)) {
            return communications.map((item: ContactHistoryT, index) => {
                switch (item.type) {
                    case "smuvsrp_quote":
                        return <ContactFormSubmission key={index} job={props.job} item={item} />
                    case "smuvsrp_chat":
                        return <ContactTranscription key={index} job={props.job} item={item} />
                    case "phone":
                        return <ContactPhone key={index} job={props.job} item={item} disputeEdit displayMode='edit' />
                    case "sms":
                        return <ContactSms key={index} job={props.job} item={item} disputeEdit displayMode='edit'/>
                    default:
                        return null;
                }

            })
        }
    }


    return (
        <div style={{ overflow: "hidden" }} className="mb-2 mt-2" >
            <div style={{ height: "100%", overflow: "auto", position: "relative"}}>
                {renderContactHistory()}
            </div>
            {/* <ButtonLoading
                    variant="success"
                    timeShowMsg={100}
                    onClickFetching={async (event) : Promise<string> => {
                        let disputeAnnotations = []
                        if (_.isArray(communications)) {
                            communications.map((item) => {
                                disputeAnnotations.push({
                                    id: item.id,
                                    disputeNotes: item.disputeNotes
                                })
                            })
                        }

                        console.log('yoo')
                        console.log(disputeAnnotations)

                        return await AxiosInstance.post(`${config.url.jobs}/${props.job.id}/communications/dispute_annotations`,
                            {
          
                            }).then((res) => {
                                return res.data
                            })
                        }
                    }>Save</ButtonLoading> */}
        </div>
    )
}


export default DisputeCommunicationsTab